import styled from 'styled-components';
import factoryButton from './utils/factoryButton';
import BaseBtnSC from './styles/BaseBtnSC';
const boxShadowDarkMode = (props) => `${props.theme.SizeShadowButtonActive} ${props.theme.ColorShadowButtonDarkContained}`;
const ButtonContainedSC = styled(BaseBtnSC) `
  height: auto;
  justify-content: center;

  &._ndsBtn--price {
    height: ${(props) => props.theme.SizeHeightButtonContainedPrice};
    justify-content: space-between;
  }

  &._ndsBtn--loading {
    justify-content: center;
  }

  color: ${(props) => props.theme.ColorFontButtonContainedPrice};
  background-color: ${(props) => props.theme.ColorBackgroundButtonContainedBase};

  &._ndsBtn--grey {
    color: ${(props) => props.theme.ColorFontButtonContainedGrey};
    background-color: ${(props) => props.theme.ColorBackgroundButtonContainedGrey};
  }

  &._ndsBtn--destructive {
    color: ${(props) => props.theme.ColorFontButtonContainedError};
    background-color: ${(props) => props.theme.ColorBackgroundButtonContainedError};
  }

  &._ndsBtn--dark-mode {
    color: ${(props) => props.theme.ColorFontButtonContainedDarkBase};
    background-color: ${(props) => props.theme.ColorBackgroundButtonContainedDarkBase};
  }

  :hover {
    background-color: ${(props) => props.theme.ColorBackgroundButtonContainedHover};
  }

  &._ndsBtn--grey:hover {
    background-color: ${(props) => props.theme.ColorBackgroundButtonContainedGreyHover};
  }

  &._ndsBtn--destructive:hover {
    background-color: ${(props) => props.theme.ColorBackgroundButtonContainedErrorHover};
  }

  &._ndsBtn--dark-mode:hover {
    background-color: ${(props) => props.theme.ColorBackgroundButtonContainedDarkHover};
  }

  :focus,
  :active {
    background-color: ${(props) => props.theme.ColorBackgroundButtonContainedActive};
  }

  &._ndsBtn--grey:focus,
  &._ndsBtn--grey:active {
    background-color: ${(props) => props.theme.ColorBackgroundButtonContainedGreyActive};
  }

  &._ndsBtn--destructive:focus,
  &._ndsBtn--destructive:active {
    background-color: ${(props) => props.theme.ColorBackgroundButtonContainedErrorActive};
  }

  &._ndsBtn--dark-mode:focus,
  &._ndsBtn--dark-mode:active {
    background-color: ${(props) => props.theme.ColorBackgroundButtonContainedDarkActive};
  }

  ::before {
    height: auto;
  }

  &._ndsBtn--price::before {
    height: ${(props) => props.theme.SizeHeightButtonContainedPrice};
  }

  &._ndsBtn--dark-mode:focus::before,
  &._ndsBtn--dark-mode:active::before {
    box-shadow: ${boxShadowDarkMode};
  }

  &._ndsBtn--grey:disabled,
  &._ndsBtn--destructive:disabled,
  :disabled {
    background-color: ${(props) => props.theme.ColorBackgroundButtonContainedDisabled};
    color: ${(props) => props.theme.ColorFontButtonContainedDisabled};
  }

  &._ndsBtn--dark-mode:disabled {
    color: ${(props) => props.theme.ColorFontButtonContainedDarkDisabled};
    background-color: ${(props) => props.theme.ColorBackgroundButtonContainedDarkDisabled};
  }

  &._ndsBtn--loading:disabled {
    background-color: ${(props) => props.theme.ColorBackgroundButtonContainedLoading};
    color: ${(props) => props.theme.ColorFontButtonContainedLoading};
  }

  &._ndsBtn--grey._ndsBtn--loading:disabled {
    background-color: ${(props) => props.theme.ColorBackgroundButtonContainedGreyLoading};
    color: ${(props) => props.theme.ColorFontButtonContainedGreyLoading};
  }

  &._ndsBtn--destructive._ndsBtn--loading:disabled {
    background-color: ${(props) => props.theme.ColorBackgroundButtonContainedErrorLoading};
    color: ${(props) => props.theme.ColorFontButtonContainedErrorLoading};
  }

  &._ndsBtn--dark-mode._ndsBtn--loading:disabled {
    opacity: 1;
    background-color: ${(props) => props.theme.ColorBackgroundButtonContainedDarkLoading};
    color: ${(props) => props.theme.ColorFontButtonContainedDarkBase};
  }

  & > svg > *,
  &._ndsBtn--destructive > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonContainedError};
  }

  &._ndsBtn--grey > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonContainedGrey};
  }

  &._ndsBtn--dark-mode > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonContainedDarkBase};
  }

  &:disabled > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonContainedDisabled};
  }

  &._ndsBtn--dark-mode:disabled > svg > * {
    fill: ${(props) => props.theme.ColorFontButtonContainedDarkDisabled};
  }
`;
export { ButtonContainedSC };
export default factoryButton(ButtonContainedSC, 'contained');
//# sourceMappingURL=ButtonContained.js.map